import { Observable } from 'rxjs';
import { Http, Response } from '@angular/http';

export class Util {

  constructor() { }

  static handleErrorMessage(error: any) {
    let errorMsg: string;
    try {
      errorMsg = error.json().message;
    } catch (e) {
      return Observable.throw(new Error("Unbekannter Fehler vom Server"));
    }
    return Observable.throw(new Error(errorMsg));

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/shared/util/util.ts